import { render } from "./CharStats.vue?vue&type=template&id=565b1376&scoped=true&ts=true"
import script from "./CharStats.vue?vue&type=script&lang=ts"
export * from "./CharStats.vue?vue&type=script&lang=ts"

import "./CharStats.vue?vue&type=style&index=0&id=565b1376&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-565b1376"]])

export default __exports__